import React from "react";

interface Props {
  className?: string;
}

const CTAIcon = (props?: Props) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props?.className}
    >
      <path
        d="M28.3838 6.75293C28.3838 6.75293 25.9638 6.74993 25.6868 8.75193L24.3868 18.4109C24.0148 20.5929 26.5198 21.0479 28.0268 21.0789C29.5338 21.1099 30.7878 19.9659 30.8278 18.5229L30.9318 15.4769L31.0848 10.9889L31.1298 9.53993C31.1298 8.33193 30.6088 7.04193 28.3838 6.75293Z"
        fill="#FFDC5D"
      />
      <path
        d="M29.2498 21.9058H25.6558L25.1558 20.2498H29.7498L29.2498 21.9058ZM20.4238 7.50579C20.4238 7.50579 20.5678 6.74179 21.7708 6.82579L21.4388 7.87679L20.4238 7.50579Z"
        fill="#FFDC5D"
      />
      <path
        d="M29 2.365C29 1.611 28.389 1 27.635 1H23.365C22.611 1 22 1.611 22 2.365V17.635C22 18.389 24.611 19 25.365 19H27.635C28.389 19 29 18.389 29 17.635V2.365Z"
        fill="#6D6E71"
      />
      <path
        d="M28 2.365C28 1.611 27.389 1 26.635 1H22.365C21.611 1 21 1.611 21 2.365V17.635C21 18.389 21.611 19 22.365 19H26.635C27.389 19 28 18.389 28 17.635V2.365Z"
        fill="#231F20"
      />
      <path d="M22 3H27V16H22V3Z" fill="#88C9F9" />
      <path
        d="M20.5452 14.1357L20.6762 14.8807L21.2132 14.8357L21.8122 14.7937C22.3022 14.7587 22.6962 14.4237 22.8342 13.9817L20.5452 14.1357ZM20.5452 11.7447L20.5652 12.4747L21.2162 12.4677C21.7412 12.4527 22.1832 12.1337 22.3882 11.6857L20.5452 11.7447ZM20.5352 9.09473L20.5462 9.81173L20.7692 9.84273C21.2932 9.87873 21.7642 9.60473 22.0112 9.17873L20.5352 9.09473ZM30.1452 10.4387L29.9862 10.4317C29.5122 10.4127 29.1082 10.7847 29.0882 11.2587L29.0152 13.7647L30.7812 14.0927L30.9132 10.9897C30.7912 10.6807 30.4972 10.4527 30.1452 10.4387Z"
        fill="#EF9645"
      />
      <path
        d="M30.4024 11.8578L30.2584 11.9248C29.8284 12.1258 29.3124 11.9388 29.1114 11.5088L28.3484 9.87783C28.1474 9.44783 28.3344 8.93183 28.7644 8.73083L28.9084 8.66383C29.3384 8.46283 29.8544 8.64983 30.0554 9.07983L30.8184 10.7108C31.0194 11.1408 30.8324 11.6568 30.4024 11.8578Z"
        fill="#EF9645"
      />
      <path
        d="M29.3246 16.1667L29.1656 16.1597C28.6916 16.1397 28.3196 15.7357 28.3386 15.2617L28.5006 11.3257C28.5206 10.8517 28.9246 10.4797 29.3986 10.4987L29.5576 10.5057C30.0316 10.5257 30.4036 10.9297 30.3846 11.4037L30.2226 15.3397C30.2036 15.8147 29.7996 16.1867 29.3246 16.1667Z"
        fill="#FFDC5D"
      />
      <path
        d="M29.8847 11.9145L29.7407 11.9815C29.3107 12.1825 28.7947 11.9955 28.5937 11.5655L27.8297 9.93449C27.6287 9.50449 27.8157 8.98849 28.2457 8.78749L28.3897 8.71949C28.8197 8.51849 29.3357 8.70549 29.5367 9.13549L30.2997 10.7665C30.5017 11.1965 30.3147 11.7135 29.8847 11.9145ZM30.8177 13.7795C30.0327 13.4475 29.1787 13.6555 28.8437 13.8935C25.9567 15.9375 26.3817 19.1015 28.3957 19.5385C30.0257 19.8915 30.5777 18.7495 30.5777 18.7495L30.7597 15.4775L30.8177 13.7795ZM20.8457 14.7895L21.0327 16.4825L21.6037 16.4335C21.6037 16.4335 21.8947 16.3965 22.1167 16.1975C22.2727 16.0585 22.3947 15.8415 22.3567 15.4935C22.2627 14.6475 21.4167 14.7405 21.4167 14.7405L20.8457 14.7895Z"
        fill="#FFDC5D"
      />
      <path
        d="M21.0486 16.4809L21.0176 16.4849C20.8706 16.5059 20.7326 16.4019 20.7116 16.2549L20.5496 15.1039C20.5286 14.9569 20.6326 14.8189 20.7796 14.7979L20.8106 14.7939C20.9576 14.7729 21.0956 14.8769 21.1166 15.0239L21.2786 16.1749C21.2996 16.3219 21.1956 16.4599 21.0486 16.4809ZM20.6946 14.3689L22.1806 14.2639C22.1806 14.2639 22.5586 14.2349 22.8346 13.9809C23.0066 13.8219 23.1396 13.5759 23.1116 13.1909C23.0406 12.1889 22.0386 12.2599 22.0386 12.2599L21.6356 12.2889L21.0366 12.3309L20.5536 12.3649L20.6946 14.3689Z"
        fill="#FFDC5D"
      />
      <path
        d="M20.7121 14.3677L20.6751 14.3707C20.5001 14.3827 20.3471 14.2497 20.3341 14.0747L20.2371 12.7067C20.2251 12.5317 20.3581 12.3787 20.5331 12.3657L20.5701 12.3627C20.7451 12.3507 20.8981 12.4837 20.9111 12.6587L21.0081 14.0267C21.0201 14.2017 20.8871 14.3557 20.7121 14.3677ZM20.7171 11.9017L20.6571 11.9037C20.4771 11.9087 20.3251 11.7657 20.3201 11.5847L20.2791 10.1077C20.2741 9.92768 20.4171 9.77568 20.5981 9.77068L20.6581 9.76868C20.8381 9.76368 20.9901 9.90668 20.9951 10.0877L21.0361 11.5647C21.0411 11.7447 20.8981 11.8967 20.7171 11.9017Z"
        fill="#FFDC5D"
      />
      <path
        d="M21.734 11.8729C21.734 11.8729 22.092 11.8559 22.387 11.6389C22.601 11.4819 22.783 11.2239 22.77 10.7769C22.74 9.71085 21.674 9.74085 21.674 9.74085L21.141 9.75585L20.627 9.76985L20.687 11.9029L21.734 11.8729ZM21.338 9.34785C21.338 9.34785 21.696 9.36585 22.011 9.17885C22.239 9.04385 22.445 8.80385 22.476 8.35785C22.55 7.29385 21.486 7.21985 21.486 7.21985L20.954 7.18285L20.806 7.17285L20.658 9.30085L21.338 9.34785Z"
        fill="#FFDC5D"
      />
      <path
        d="M20.688 9.30268L20.628 9.29868C20.448 9.28568 20.311 9.12868 20.323 8.94868L20.425 7.47468C20.438 7.29468 20.595 7.15768 20.775 7.16968L20.835 7.17368C21.015 7.18668 21.152 7.34368 21.14 7.52368L21.038 8.99768C21.025 9.17868 20.868 9.31568 20.688 9.30268Z"
        fill="#FFDC5D"
      />
      <path
        d="M29.25 21H25.458C25.047 21 24.875 21.203 24.26 22.211L19.878 28.91L6.5 25.871V36H22.865C24.198 36 25.398 35.693 25.9 34.458L30.533 22.832C30.958 21.5 30.197 21 29.25 21Z"
        fill="#FA743E"
      />
    </svg>
  );
};

export default CTAIcon;
